<template>
  <div class="preview-loader">
    <p>Loading the preview...</p>
  </div>
</template>

<script>
export default {
  name: 'PrismicPreview',
  async mounted() {
    const { token, documentId } = this.$route.query
    
    // Check if the token is present in the URL
    if (token) {
      try {
        const client = this.$prismic.client || this.$prismic;

        const linkResolver = (doc) => {
          const langPrefix = doc.lang && doc.lang.startsWith('es') ? '/es' : '/en';
          
          if (doc.type === 'clc_new_home_page') return `${langPrefix}/`;
          if (doc.type === 'clc_news') return `${langPrefix}/news/${doc.uid}`;
          
          // Fallback para tipos antiguos o desconocidos
          return '/';
        }

        const url = await client.resolvePreviewURL({
          linkResolver, 
          defaultUrl: '/',
          previewToken: token,
          documentId: documentId
        });

        // Redirect to the resolved URL
        window.location.replace(url);
      } catch (error) {
        console.error('Prismic preview error:', error);
        // If error, redirect home
        this.$router.push('/');
      }
    } else {
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>
.preview-loader {
  display: flex;
  justify-content: center;
  align-items: center; 
  height: 100vh;
  font-size: 20px;
}
</style>
